/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_BANK_ACCOUNT_LIST (state, val) {
    state.bankAccountList = val
  },
  UPDATE_BANK_ACCOUNT_LIST (state, val) {
    state.bankAccountList.push(...val)
  },
  ADD_BANK_ACCOUNT (state, val) {
    state.bankAccountList.unshift(val)
  },
  UPDATE_BANK_ACCOUNT (state, val) {        
    const i = state.bankAccountList.findIndex((e) => e.id === val.id)
    Object.assign(state.bankAccountList[i], val)
  },
}
